import React, { Component } from "react";
import { Link } from "react-router-dom";
import Center from "react-center";
import { connect } from "react-redux";
import { proceedToDashboard } from "SignupActions";
import { withRouter } from "react-router-dom";

class SignupDashboard extends Component {
  constructor(props) {
    super(props);
    this.onButtonClick = this.onButtonClick.bind(this);
  }

  onButtonClick(event) {
    this.props.proceedToDashboard();
    this.props.history.push("/dashboard");
  }

  render() {
    return (
      <div className="steps-animation">
        <div className="row">
          <div className="col-md-3" />
          <div className="col-md-6">
            <div>
              <Center>
                <img src="../../style/images/Astronaut.png" alt="Astronaut" />
              </Center>
            </div>
          </div>
          <div className="col-md-3" />
        </div>
        <div className="row">
          <div className="col-md-12">&nbsp;</div>
        </div>
        <div className="row">
          <div className="col-md-3" />
          <div className="col-md-6 horizontal-align-center verify-title">
            Your Account is Ready!
          </div>
          <div className="col-md-3" />
        </div>
        <div className="row">
          <div className="col-md-3" />
          <div className="col-md-6 horizontal-align-center verify-desc">
            <div>Thank you for creating account with Eventify.</div>
            <div>
              Go to your dashboard and continue building your first event app!
            </div>
          </div>
          <div className="col-md-3" />
        </div>
        <div className="row">
          <div className="col-md-12">&nbsp;</div>
        </div>
        <div className="row">
          <div className="col-md-4" />
          <div className="col-md-4">
            <button
              type="button"
              className="btn btn-default btn-social-login"
              onClick={this.onButtonClick}
            >
              Go to Dashboard
            </button>
          </div>
          <div className="col-md-4" />
        </div>
        <div className="row">
          <div className="col-md-12">&nbsp;</div>
        </div>
        <div className="row">
          <div className="col-md-12">&nbsp;</div>
        </div>
      </div>
    );
  }
}

function mapStateToProps() {
  return {};
}

export default withRouter(
  connect(mapStateToProps, { proceedToDashboard })(SignupDashboard)
);
